"use client";

import { IResponsible } from "@/core/ResponsibleCore";
import { ScopeEnum } from "@/core/ScopesCore";
import { pageTranslations, TLanguages } from "@/i18n/i18n";
import Link from "@/i18n/i18n-link";
import { User2Icon } from "lucide-react";
import { Button } from "../ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

interface ListResponsiblesProps extends IResponsible {
  scope: ScopeEnum[];
}

export function ListResponsibles({
  responsibles,
  lang,
}: {
  responsibles: ListResponsiblesProps[];
  lang: string;
}) {
  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>
              {pageTranslations.common["email"][lang as TLanguages]}
            </TableHead>
            <TableHead>
              {pageTranslations.common["name"][lang as TLanguages]}
            </TableHead>
            <TableHead>
              {pageTranslations.common["area"][lang as TLanguages]}
            </TableHead>
            <TableHead>
              {pageTranslations.common["scope"][lang as TLanguages]}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {responsibles.map((resp) => {
            return (
              <TableRow key={resp.id}>
                <TableCell>{resp.email}</TableCell>
                <TableCell>{resp.name}</TableCell>
                <TableCell>{resp.team}</TableCell>
                <TableCell>
                  {resp.scope.map((scope, index) => (
                    <span key={index} className="inline-block mr-2">
                      {scope}
                    </span>
                  ))}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
}

export function RespIcon() {
  return (
    <Button asChild variant={"ghost"}>
      <Link href="/responsibles">
        <User2Icon className="h-4 w-4" />
      </Link>
    </Button>
  );
}
